import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const removableAssetsCountForWorkbook = api(function removableAssetsCountForWorkbook({
    registerId,
    workbookIdentifier,
}) {
    if (!registerId || !workbookIdentifier) return 0
    return query(
        gql`
            query RemovableAssetsCountForWorkbook($registerId: String!, $workbookIdentifier: String!) {
                removableAssetsCountForWorkbook(registerId: $registerId, workbookIdentifier: $workbookIdentifier)
            }
        `,
        { registerId, workbookIdentifier },
        { returns: "removableAssetsCountForWorkbook" }
    )
})
